import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getCurrentUserBackends = (token: string) => {
    return fetch(`${getApiUrl()}auth/me`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    }) 
}

export default getCurrentUserBackends